/**
 * Source catalog: English is the main language. Other locales are partial copies of these keys;
 * a key a locale does not have falls back to English.
 */
export const en = {
  appName: 'RefeGo',
  signIn: 'Sign in',
  signOut: 'Sign out',
  email: 'E-mail',
  continueEmail: 'Continue with e-mail',
  checkInbox: 'Check your inbox',
  checkInboxText: 'We sent a sign-in link to {email}. It works once and expires in 5 minutes.',
  loginTitle: 'Referral & affiliate programs, without the spreadsheet.',
  loginLead: 'Sign in or create an account with a one-time link. No passwords.',
  orContinue: 'or continue with',
  overview: 'Overview',
  partners: 'Partners',
  commissions: 'Commissions',
  payouts: 'Payouts',
  fraud: 'Fraud review',
  settings: 'Settings',
  billing: 'Billing',
  audit: 'Audit log',
  partnerDashboard: 'Partner dashboard',
  ownerDashboard: 'Program dashboard',
  earnings: 'Earnings',
  programs: 'Programs',
  links: 'Links',
  revenue: 'Revenue from partners',
  clicks: 'Clicks',
  sales: 'Sales',
  activePartners: 'Active partners',
  pendingHold: 'In hold',
  available: 'Available',
  paid: 'Paid',
  onHold: 'On hold',
  applications: 'Applications',
  last30: 'Last 30 days',
  setupChecklist: 'Setup checklist',
  ckProgram: 'Create the program',
  ckStripe: 'Connect Stripe',
  ckPartner: 'Approve your first partner',
  ckClick: 'See the first click',
  ckConversion: 'Get the first conversion',
  ckPayouts: 'Connect a payout account',
  recentActivity: 'Recent activity',
  noActivity: 'Nothing happened yet.',
  testMode: 'Test mode',
  testModeText: 'Run click → payment → commission → payout without real money.',
  simulatePurchase: 'Simulate a purchase',
  releaseHolds: 'Fast-forward holds',
  amount: 'Amount',
  partner: 'Partner',
  status: 'Status',
  created: 'Created',
  actions: 'Actions',
  approve: 'Approve',
  reject: 'Reject',
  block: 'Block',
  invite: 'Invite partner',
  invitePartnerText: 'They get an approved enrollment and a link to their dashboard.',
  name: 'Name',
  send: 'Send',
  cancel: 'Cancel',
  save: 'Save',
  saved: 'Saved',
  copy: 'Copy',
  copied: 'Copied',
  close: 'Close',
  balance: 'Balance',
  earningsTotal: 'Earnings',
  method: 'Payout method',
  none: '—',
  all: 'All',
  explain: 'Why this amount',
  sale: 'Sale',
  rate: 'Rate',
  holdEnds: 'Hold ends',
  termsVersion: 'Terms version',
  holdReason: 'Hold reason',
  ledger: 'Ledger',
  draftBatch: 'Draft payout batch',
  draftTestBatch: 'Draft test batch',
  noPayable: 'Nobody is ready for a payout yet.',
  approveBatch: 'Approve & send',
  cancelBatch: 'Cancel draft',
  exportCsv: 'Export CSV',
  markPaid: 'Mark paid',
  txReference: 'Transaction hash or reference',
  batch: 'Batch',
  total: 'Total',
  provider: 'Provider',
  stepUpTitle: 'Confirm it’s you',
  stepUpText:
    'Money actions need a sign-in from the last 15 minutes. We’ll e-mail you a fresh link that brings you back here.',
  sendLink: 'Send link',
  program: 'Program',
  integrations: 'Integrations',
  domains: 'Domains',
  apiKeys: 'API keys',
  team: 'Team',
  website: 'Website',
  description: 'Description',
  autoApprove: 'Approve applications automatically',
  published: 'Program page is public',
  rewards: 'Reward',
  holdDays: 'Hold',
  minPayout: 'Minimum payout',
  days: 'days',
  standardsNote:
    'RefeGo standard for every program: commissions for {months} months from the first payment, cookie window {days} days.',
  advanced: 'Advanced',
  saveTerms: 'Save as new terms version',
  stripeTitle: 'Stripe',
  stripeText:
    'Add a webhook endpoint in Stripe → Developers → Webhooks with the URL below and these events, then paste its signing secret.',
  webhookUrl: 'Webhook URL',
  webhookSecret: 'Signing secret (whsec_…)',
  restrictedKey: 'Restricted key (optional, for promo codes and Connect transfers)',
  connected: 'Connected',
  notConnected: 'Not connected',
  connect: 'Connect',
  disconnect: 'Disconnect',
  paypalTitle: 'PayPal Payouts',
  paypalText:
    'Payouts are sent from your own PayPal Business balance. Create a REST app in the PayPal developer dashboard.',
  clientId: 'Client ID',
  clientSecret: 'Client secret',
  mode: 'Mode',
  live: 'Live',
  test: 'Test',
  addDomain: 'Add domain',
  hostname: 'Subdomain',
  domainKind: 'Used for',
  kindLinks: 'Referral links',
  kindPortal: 'Partner portal',
  dnsRecords: 'Add these DNS records at your registrar',
  newKey: 'Create key',
  keyOnce: 'Copy the key now — it is shown only once.',
  scopes: 'Scopes',
  lastUsed: 'Last used',
  revoke: 'Revoke',
  revoked: 'Revoked',
  role: 'Role',
  inviteMember: 'Invite member',
  remove: 'Remove',
  trackingSnippet: 'Tracking script',
  trackingText:
    'Add to every page of your site. It stores the referral token for checkout; pass RefeGo.token() as client_reference_id of the Stripe Checkout Session.',
  feeThisMonth: 'Platform fee this month',
  payoutVolume: 'Paid out to partners this month',
  pricingTitle: 'Pricing',
  pricingText:
    'Free up to $1,000 in monthly payouts. Then 1% of the part up to $10,000 and 2% above, with a $29 minimum.',
  invoices: 'Invoices',
  month: 'Month',
  fee: 'Fee',
  onboardingTitle: 'Launch your partner program',
  onboardingLead: 'Three questions. Everything else has a sensible default you can change later.',
  company: 'Company',
  programName: 'Program name',
  rewardTemplate: 'Reward',
  rewardCustom: 'Custom',
  percentOfSale: '% of each sale',
  fixedPerLead: 'fixed per lead',
  create: 'Create program',
  joinProgram: 'Become a partner',
  applyTitle: 'Apply to the partner program',
  country: 'Country (ISO code)',
  message: 'How will you promote us?',
  applyDone: 'Application sent',
  applyDoneText:
    'Sign in with the same e-mail to follow the status. Approved partners get their link right away.',
  youEarn: 'You earn',
  perSale: 'of every payment',
  forMonths: 'for {months} months per customer',
  cookieDays: '{days}-day cookie',
  payoutsFrom: 'payouts from {amount}',
  joined: 'You’re a partner',
  pendingReview: 'Application under review',
  nextPayout: 'Next release',
  yourLinks: 'Your links',
  createLink: 'Create link',
  code: 'Code',
  subId: 'Sub-ID (optional)',
  destination: 'Destination',
  coupon: 'Coupon',
  noPrograms: 'You haven’t joined any program yet.',
  noProgramsText: 'Open a program page from a company you want to promote and apply in one click.',
  setMethod: 'Set payout method',
  methodPending: 'Waiting for e-mail confirmation',
  methodCooldown: 'Confirmed. Payouts to these details start 72 hours after the change.',
  methodVerified: 'Verified',
  confirmEmail: 'Check your e-mail to confirm the change.',
  asset: 'Asset',
  network: 'Network',
  address: 'Wallet address',
  paypalEmail: 'PayPal e-mail',
  stripeAccount: 'Stripe account ID (acct_…)',
  history: 'History',
  statement: 'Statement (CSV)',
  confirmPayoutDone: 'Payout details confirmed.',
  confirmPayoutFail: 'The link is invalid or already used.',
  becomePartnerProfile: 'Create my partner profile',
  rule: 'Rule',
  evidence: 'Evidence',
  noFlags: 'No open flags. Suspicious commissions stay on hold here until you decide.',
  emptyPartners: 'No partners yet',
  emptyPartnersText: 'Share your program page or invite partners by e-mail.',
  programPage: 'Program page',
  emptyCommissions: 'No commissions yet',
  emptyCommissionsText: 'They appear after the first attributed payment. Try the simulator in test mode.',
  loading: 'Loading…',
  error: 'Something went wrong',
  pickWorkspace: 'Workspace',
  createWorkspace: 'New program',
  dualApproval: 'Batches above {amount} need a second approver.',
  willCost: 'At this volume RefeGo charges',
  webhooks: 'Webhooks',
  coupons: 'Coupons',
  addEndpoint: 'Add endpoint',
  endpointUrl: 'Endpoint URL (https)',
  events: 'Events',
  allEvents: 'All events',
  secretOnce: 'Signing secret — shown once. Verify the RefeGo-Signature header: HMAC-SHA256 of "<t>.<body>".',
  sendTest: 'Send test event',
  deliveries: 'Recent deliveries',
  retry: 'Retry',
  noEndpoints: 'No endpoints yet. Events are signed with HMAC-SHA256 and retried with backoff.',
  addCoupon: 'Assign coupon',
  couponCode: 'Promo code',
  stripePromo: 'Stripe promotion code ID (promo_…, optional)',
  rateOverride: 'Rate override, % (optional)',
  couponsHint: 'One code belongs to one partner. A coupon beats the cookie: the buyer typed it explicitly.',
  customers: 'Customers',
  mfaTitle: 'Two-factor authentication',
  mfaSetupLead:
    'The program dashboard moves money, so the team signs in with a second factor. Scan the QR code with an authenticator app (1Password, Google Authenticator, Authy) and enter the 6-digit code.',
  mfaChallengeLead: 'Enter the 6-digit code from your authenticator app.',
  mfaSecret: 'Or enter this key manually',
  mfaCode: 'Code',
  verify: 'Verify',
  mfaDone: 'Two-factor authentication is on.',
  mfaOptional: 'Protect your payouts with a second factor (recommended).',
  enable2fa: 'Enable two-factor authentication',
  stepUpTotp: 'Money actions need a recent sign-in. Enter the code from your authenticator app.',
  testTransfer: 'Test transfer',
  confirmReceipt: 'Confirm receipt',
  testTransferHint:
    'A small test transfer was sent to your new crypto address. Confirm it arrived — regular payouts to this address start after that.',
  payoutsPausedBilling:
    'Payouts are paused: the RefeGo invoice is overdue. Tracking and commissions keep working; payouts resume automatically once the invoice is paid.',
  payoutsPausedManual: 'Payouts are paused for this workspace.',
  dueDate: 'Due',
  groups: 'Groups',
  groupsHint:
    'A group gives its partners their own reward, hold, a discount for customers, a landing text and extra application questions. Changing a group creates a new version; earned commissions keep theirs.',
  defaultGroup: 'Default group · program terms',
  partnersCount: '{n} partners',
  questionsCount: '{n} questions',
  addGroup: 'New group',
  editGroup: 'Edit group',
  groupName: 'Group name',
  groupSlug: 'Link slug (?group=)',
  ownReward: 'Own reward for this group',
  rewardType: 'Type',
  rewardValue: 'Value',
  asProgram: 'As in the program',
  customerDiscount: 'Customer discount',
  months: 'Months',
  discountHint: 'Shown on the group page. Create the matching coupon in Stripe and assign it to partners.',
  landerHeadline: 'Landing headline',
  landerBody: 'Landing text',
  applicationQuestions: 'Extra application questions',
  question: 'Question',
  required: 'required',
  archive: 'Archive',
  archiveGroupConfirm:
    'Archive the group? Its partners move to the default group; earned commissions keep their terms.',
  edit: 'Edit',
  group: 'Group',
  moveToGroup: 'Move to group',
  yourGroup: 'Your group',
  billingCard: 'Card for RefeGo invoices',
  noCard: 'No card yet. Invoices arrive by e-mail with a payment link.',
  cardProcessing: 'Card saved in Stripe, updating…',
  addCard: 'Add card',
  replaceCard: 'Replace card',
  payInvoice: 'Pay',
  consentExpired: 'This request has expired. Connect again from the application.',
  consentTitle: '{client} wants to connect to RefeGo',
  consentRedirect: 'It will return to',
  consentAccount: 'Account',
  consentScopes: 'Access',
  consentNoTargets: 'You have no workspace or partner account to connect.',
  consentNoScopes: 'Your role does not allow any of the requested access.',
  consentNote:
    'The app acts with your rights. It can draft payout batches but never approve or send money. Revoke access any time in Settings → API keys.',
  consentAllow: 'Allow',
  consentDeny: 'Deny',
  scope_programs_read: 'program and stats',
  scope_partners_read: 'partners and applications',
  scope_partners_write: 'approve and reject applications',
  scope_commissions_read: 'commissions and fraud flags',
  scope_payouts_write: 'draft payout batches',
  scope_partner_read: 'your programs, links and earnings',
  scope_partner_write: 'create referral links',
  connectedApps: 'Connected apps (MCP)',
  connectedAppsHint: 'Apps you connected through OAuth. Revoking takes effect immediately.',
  noConnectedApps: 'No connected apps.',
  domainErr_txt_not_found: 'TXT record not found yet. DNS changes can take up to an hour.',
  domainErr_cname_not_target: 'The CNAME points elsewhere. Point it to the target shown above.',
  domainErr_cloudflare_for_saas_not_configured:
    'DNS verified. Certificates for custom domains are being enabled on our side; the domain turns active automatically.',
  domainErr_dns_missing_7_days:
    'Switched off: the DNS records were missing for 7 days. Remove and add the domain again.',
  enrollmentPending: 'Pending review',
  websiteHint: 'Partner links can only point to this domain.',
  'status.pending': 'In hold',
  'status.available': 'Available',
  'status.on_hold': 'On hold',
  'status.in_payout': 'In payout',
  'status.paid': 'Paid',
  'status.reversed': 'Reversed',
  'status.clawed_back': 'Clawed back',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.blocked': 'Blocked',
  'status.draft': 'Draft',
  'status.queued': 'Queued',
  'status.sending': 'Sending',
  'status.sent': 'Sent',
  'status.failed': 'Failed',
  'status.cancelled': 'Cancelled',
  'status.completed': 'Completed',
  'status.open': 'Open',
  'status.accepted': 'Accepted',
  'status.pending_dns': 'Waiting for DNS',
  'status.issuing_cert': 'Issuing certificate',
  'status.active': 'Active',
  'status.error': 'Error',
  'status.disabled': 'Disabled',
  'skip.below_minimum': 'Some balances are below the minimum payout.',
  'skip.no_method': 'Some partners have no payout method yet.',
  'skip.method_unverified': 'Some payout details are not confirmed by e-mail.',
  'skip.method_cooldown': 'Payout details changed less than 72 hours ago.',
  'skip.fraud_flags': 'Partners with open fraud flags are held — see Fraud review.',
  'skip.paused': 'Payouts are paused for this workspace.',
  'skip.crypto_test_pending':
    'A test transfer to a new crypto address must be confirmed by the partner first.',
  'skip.nothing_available': 'Nothing is available yet — commissions are still in hold.',
}

export type Dict = typeof en
export type Catalog = Partial<Dict>
